// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__19-ND","file":"styles_file__261jM"};